import React, { Component } from 'react';

class tenantVehicles extends Component {
  avatarStyle = url => {
    return {
      height: '120px',
      width: '120px',
      float: 'right',
      border: '0px solid #e1e1e1',
      boxShadow: 'none',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      marginRight: '20px',
      backgroundPosition: '50% 0',
      backgroundImage: 'url(' + url + ')',
    };
  };

  render() {
    const style = {
      header: {
        color: '#4e4e4e',
        fontSize: '18px',
        marginBottom: '0',
        marginTop: '0',
      },
      sub_header: {
        marginTop: '5px',
        marginBottom: 0,
        color: '#6F6F6F',
        textAlign: 'justify',
      },
      subMenuHeader: {
        backgroundColor: '#f7f7f7',
        margin: '20px -15px',
        textAlign: 'center',
        color: '#888888',
      },
    };

    let tenantVehicles = this.props.vehicles || [];

    if (tenantVehicles.length !== 0) {
      tenantVehicles = tenantVehicles.map((tenantVehicle, index) => (
        <div key={index} className="row">
          <div className="wrapper">
            <div className="col-sm-5 col-sm-offset-1">
              <h5 style={style.header}>
                <b>{tenantVehicle.make}</b>
              </h5>
              <h5 style={style.sub_header}>
                Vehicle Type <b>{tenantVehicle.vehicle_type}</b>
              </h5>
              <h5 style={style.sub_header}>
                Vehicle Color <b>{tenantVehicle.color}</b>
              </h5>
              <h5 style={style.sub_header}>
                Plate Number <b>{tenantVehicle.plate_number}</b>
              </h5>
            </div>
          </div>
        </div>
      ));
    } else {
      tenantVehicles = (
        <div style={{ textAlign: 'center' }}>
          <small>No Vehicles.</small>
        </div>
      );
    }

    return (
      <div>
        <div className="row" style={style.subMenuHeader}>
          <h5> Vehicles </h5>
        </div>

        <div className="row">{tenantVehicles}</div>
      </div>
    );
  }
}

export default tenantVehicles;
